import React from 'react';
import { Divider } from '@mui/material';
import { primaryList } from '../data';
import ListItemButton from '../ListItemButton';
import CollapsibleItemLink from '../CollapsibleItemLink';
import List from '../NavigationList';
import Notifications from '../../Notifications';

export default function ListItemLink() {
  const [selectedIndex, setSelectedIndex] = React.useState(0);
  const [subItemSelectedIndex, setSubItemSelectedIndex] = React.useState(-1);

  const handleClick = (index: number) => {
    setSelectedIndex(index);
  };

  const handleSubItemClick = (index: number) => {
    setSubItemSelectedIndex(index);
  };

  return (
    <List dense>
      {primaryList.map((item) => {
        return (
          <React.Fragment key={item.id}>
            {!item.collapsible ? (
              <ListItemButton
                key={item.id}
                isLink={true}
                open={false}
                item={item}
                selected={item.id === selectedIndex}
                handleClick={() => handleClick(item.id)}
              />
            ) : (
              <CollapsibleItemLink
                key={item.id}
                item={item}
                selectedIndex={selectedIndex}
                subItemSelectedIndex={subItemSelectedIndex}
                handleSelect={handleClick}
                handleSubItemSelect={handleSubItemClick}
              />
            )}
          </React.Fragment>
        );
      })}
      <Divider component="div" role="presentation" sx={{ bgcolor: 'lightGrey', mb: 2 }} />
      <Notifications />
    </List>
  );
}
